import React from "react";
import { useLanguagesContext } from "hooks/useContextAll";

const PageTitle = (props) => {
    const language = useLanguagesContext();

    return (
        <div
            className={`page-title font-code ${
                language.language === "en" ? "ltr" : "rtl"
            }`}
        >
            <h2>&lt;{props.text} &#47;&gt;</h2>
        </div>
    );
};

export default PageTitle;
